export default "__VITE_ASSET__B60x5doo__"